/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlTextCondition
 */
export interface ControlTextCondition {
    /**
     * 
     * @type {string}
     * @memberof ControlTextCondition
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTextCondition
     */
    question_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlTextCondition
     */
    value: string;
}

/**
 * Check if a given object implements the ControlTextCondition interface.
 */
export function instanceOfControlTextCondition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "question_id" in value;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function ControlTextConditionFromJSON(json: any): ControlTextCondition {
    return ControlTextConditionFromJSONTyped(json, false);
}

export function ControlTextConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlTextCondition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': !exists(json, 'type') ? undefined : json['type'],
        'question_id': json['question_id'],
        'value': json['value'],
    };
}

export function ControlTextConditionToJSON(value?: ControlTextCondition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'question_id': value.question_id,
        'value': value.value,
    };
}

